import { observer } from 'mobx-react-lite';
import { FileProviderAriaText } from '../strings.locstring.json';
import { ComputerFileProviderDisplayName } from './LocalComputerFileProviderView.locstring.json';
import loc, { format } from 'owa-localize';
import FileProviderView from './FileProviderView';
import LocalComputerFilePicker from './LocalComputerFilePicker';
import { getIconForFileProvider as getLocalComputerIconCSS } from 'owa-fileprovider-icon';
import { FileSelectionFilter } from 'owa-fileprovider-store';

import * as React from 'react';
import { ControlIcons } from 'owa-control-icons';

const styles = require('./LocalComputerFileProviderView.scss');

export interface LocalComputerFileProviderViewProps {
    onFilesSelected: (files: File[], fileSelectionFilter: FileSelectionFilter) => void;
    fileSelectionFilter: FileSelectionFilter;
    onLocalComputerClicked: () => void;
}

export default observer(function LocalComputerFileProviderView(
    props: LocalComputerFileProviderViewProps
) {
    const localComputerFilePicker = React.useRef<LocalComputerFilePicker>();
    const onFilesSelected = (files: File[]) => {
        props.onFilesSelected(files, props.fileSelectionFilter);
    };
    const onLocalComputerFileProviderClicked = () => {
        props.onLocalComputerClicked();
        localComputerFilePicker.current.click();
    };
    return (
        <div>
            <FileProviderView
                name={loc(ComputerFileProviderDisplayName)}
                icon={getLocalComputerIconCSS(ControlIcons.System, styles.computerImage)}
                onClick={onLocalComputerFileProviderClicked}
                ariaLabel={format(loc(FileProviderAriaText), loc(ComputerFileProviderDisplayName))}
            />

            <LocalComputerFilePicker
                ref={ref => (localComputerFilePicker.current = ref)}
                onFilesSelected={onFilesSelected}
                fileSelectionFilter={props.fileSelectionFilter}
            />
        </div>
    );
});
